import * as IconTarget from './icons';

export type IconProps = {
  width?: number | string;
  height?: number | string;
  color?: string;
  viewBox?: string;
};

export type IconType = keyof typeof IconTarget;
export const IconTypes = Object.keys(IconTarget) as IconType[];

interface Props extends IconProps {
  name: IconType;
}

const Icon = ({ name, ...props }: Props) => {
  const IconComponent = IconTarget[name];

  if (!IconComponent) {
    return null;
  }

  return <IconComponent {...props} />;
};

export default Icon;
